const unformatPrice = (value) => {
  if (!value) return null;
  return value.replaceAll(".", "").replace(",", ".");
};

export default unformatPrice;
